import { slideDown, slideUp } from "./helpers/plainSlide.js";

class NewsLoader {
  constructor() {
    this.newsLoaders = document.querySelectorAll(".js-news-loader");

    if (this.newsLoaders && this.newsLoaders.length) {
      this.initNewsLoadmore();
    }
  }

  initNewsLoadmore() {
    const that = this;
    let i = 0;

    while (i < that.newsLoaders.length) {
      const button = that.newsLoaders[i];
      that.newsLoaders[i].onclick = (e) => {
        e.preventDefault();
        button.setAttribute("disabled", true);
        button.classList.add("is-loading");
        that.requestAjaxRequest(button);
      };

      i++;
    }
  }

  requestAjaxRequest(loadmoreButton) {
    const that = this;
    if (loadmoreButton) {
      const nonce = loadmoreButton.hasAttribute("data-nonce")
        ? loadmoreButton.getAttribute("data-nonce")
        : false;
      const paged = loadmoreButton.hasAttribute("data-paged")
        ? loadmoreButton.getAttribute("data-paged")
        : 1;

      if (!nonce) {
        return console.log("Nonce not found");
      }

      const loadmoreData = new FormData();
      loadmoreData.append("action", "news_loader");
      loadmoreData.append("nonce", nonce);
      loadmoreData.append("paged", paged);

      // Fetch
      fetch(ajaxURL, {
        method: "POST",
        body: loadmoreData,
      })
        .then((response) => response.json())
        .then((data) => setTimeout(() => {that.handleLoadedData(data, loadmoreButton), 60000}))
        .catch((error) => console.log(error));
    }
  }

  handleLoadedData(data, loadmoreButton) {
    if (data && data.success) {
      const newsList = loadmoreButton.parentElement.previousElementSibling;

      // Update loadmore configs
      loadmoreButton.removeAttribute("disabled", false);
      loadmoreButton.setAttribute("data-paged", data.paged);
      loadmoreButton.classList.remove("is-loading");

      // Append data to News List
      if (newsList && data.html) {
        newsList.innerHTML += data.html;
        window.scrollTo({
          top: window.pageYOffset + 200,
          behavior: "smooth",
        });
      }

      // hide button if its end of the pagination
      if (data.hide_button) {
        loadmoreButton.setAttribute("disabled", true);
        slideUp(loadmoreButton.parentElement);
      }
    } else {
      loadmoreButton.removeAttribute("disabled", false);
      loadmoreButton.classList.remove("is-loading");
    }
  }
}

new NewsLoader();
